import request from '@/utils/axios';
export function postUploadImgCms(data) {
    return request({
        url: '/bpis/common/pmCmsSystemRelay?path=' + '/File/Upload',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----'
        },
    })
}
